import React from 'react';
import { TextStyled } from '@nike/nike-design-system-components';

const ContentModalLevel3: React.FC = () => {
  return (
    <TextStyled >
      Level 3 will permanently lock the user out of their account.
      <TextStyled display="block" style={{ fontStyle: 'italic' }} >
        This can not be undone.
      </TextStyled>
    </TextStyled>
  );
};

export default ContentModalLevel3;
